export interface IntroAssessmentSnapshot {
  reading: string;
  steps: string[];
  pending: string[];
  helpLabels: string[];
  lang: "es" | "en";
}

export function createIntroSnapshot(
  result: { reading: string; steps: string[] }, pending: string[], labels: Record<string, string>, lang: "es" | "en",
): IntroAssessmentSnapshot {
  if (!result.reading.trim() || result.steps.length !== 3 || result.steps.some((s) => !s.trim())) {
    throw new Error("invalid assessment");
  }
  return { reading: result.reading, steps: [...result.steps], pending: [...pending], helpLabels: pending.map((key) => labels[key] ?? key), lang };
}

export function orderIntroHistory<T extends { kind: string; created_at: string | null }>(rows: T[]): T[] {
  return [...rows].sort((a, b) => {
    if (a.kind !== b.kind) return a.kind === "initial" ? -1 : 1;
    return (a.created_at ?? "").localeCompare(b.created_at ?? "");
  });
}